// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 시세수집 화면 */

/* ── 툴바 ── */
.pc-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.pc-toolbar-sep {
  width: 1px;
  height: 20px;
  background: #ddd;
  margin: 0 4px;
}

.pc-check-label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  color: #444;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.pc-check-label input[type="checkbox"] {
  width: 15px;
  height: 15px;
  cursor: pointer;
}

.pc-schedule-badge {
  font-size: 12px;
  color: #555;
  margin-left: 4px;
}

.badge-on  { color: #0a8a00; }
.badge-off { color: #999; }

.btn-outline-active {
  background: #eef0ff;
  border-color: #4060d0;
  color: #4060d0;
}

/* ── 바디 ── */
.pc-body {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
  gap: 12px;
  overflow-y: auto;
  padding: 4px 2px 12px;
}

/* ── 카드 공통 ── */
.pc-card {
  border: 1px solid #dde2ef;
  border-radius: 6px;
  background: white;
  overflow: hidden;
  flex-shrink: 0;
}

.pc-card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: #f0f2f8;
  font-size: 13px;
  font-weight: 600;
  color: #1a1a2e;
  border-bottom: 1px solid #dde2ef;
}

.pc-card-body {
  padding: 12px;
}

/* ── 스케줄 설정 카드 ── */
.schedule-body {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.schedule-row {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 13px;
}

.schedule-label {
  width: 100px;
  color: #555;
  flex-shrink: 0;
}

.schedule-input {
  flex: 1 1;
  max-width: 280px;
  padding: 5px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 13px;
  font-family: monospace;
}

.schedule-value {
  font-family: monospace;
  font-size: 13px;
  color: #333;
  background: #f8f8f8;
  padding: 4px 8px;
  border-radius: 4px;
}

.schedule-hint {
  font-size: 11px;
  color: #888;
  margin: 0;
}

.schedule-hint code {
  background: #f0f0f0;
  padding: 1px 4px;
  border-radius: 3px;
  font-size: 11px;
}

/* ON/OFF 토글 버튼 */
.toggle-btn {
  padding: 4px 16px;
  border-radius: 12px;
  border: none;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s;
}

.toggle-on {
  background: #0a8a00;
  color: white;
}

.toggle-off {
  background: #ccc;
  color: #666;
}

.toggle-btn:disabled {
  opacity: 0.7;
  cursor: default;
}

/* ── 수집 결과 카드 ── */
.result-mode {
  font-size: 11px;
  background: #eef0ff;
  color: #3050c8;
  padding: 2px 8px;
  border-radius: 10px;
  font-weight: 500;
}

.result-counts {
  font-size: 12px;
  font-weight: 400;
  margin-left: auto;
  color: #555;
}

.result-success { color: #0a8a00; }
.result-fail    { color: #cc0000; }

/* 시장지수 한 줄 표시 */
.market-index-row {
  display: flex;
  gap: 16px;
  padding: 8px 12px;
  background: #fafbff;
  border-bottom: 1px solid #eee;
  flex-wrap: wrap;
}

.market-index-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 80px;
}

.mi-label {
  font-size: 10px;
  color: #888;
}

.mi-value {
  font-size: 13px;
  font-weight: 600;
  color: #1a1a2e;
}

/* 결과 테이블 */
.pc-result-table-wrap {
  max-height: 250px;
  overflow-y: auto;
  padding: 0 12px 10px;
}

.pc-result-table td,
.pc-result-table th {
  font-size: 12px;
}

.row-fail td { color: #cc0000; background: #fff5f5; }
.status-success { color: #0a8a00; font-weight: 600; }
.status-fail    { color: #cc0000; font-weight: 600; }
.td-error { font-size: 11px; color: #999; max-width: 300px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

/* ── 최신시세 / 수동입력 테이블 ── */
.pc-table-wrap {
  overflow-x: auto;
  max-height: 300px;
  overflow-y: auto;
}

.pc-price-table td,
.pc-price-table th {
  font-size: 12px;
  white-space: nowrap;
}

.price-cell {
  font-weight: 600;
  color: #1a1a2e;
}

.col-right {
  text-align: right !important;
}

/* ── 시장지수 과거데이터 수집 섹션 ── */
.pc-hist-card {
  border-left: 3px solid #4a90e2;
}
.pc-hist-body {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  padding: 8px 0;
}
.pc-hist-label {
  font-size: 13px;
  color: #555;
  white-space: nowrap;
}
.pc-hist-date {
  padding: 4px 8px;
  font-size: 13px;
  border: 1px solid #d0d7de;
  border-radius: 4px;
  background: #fff;
}
.pc-hist-progress {
  font-size: 12px;
  color: #4a90e2;
  animation: blink 1s step-end infinite;
}
@keyframes blink { 50% { opacity: 0; } }
.pc-hist-result {
  font-size: 13px;
  font-weight: 600;
}
.pc-hist-result.success { color: #27ae60; }
.pc-hist-result.error   { color: #e74c3c; }
.pc-hist-hint {
  font-size: 11px;
  color: #888;
  margin: 4px 0 0;
}

/* 수동입력 필드 */
.manual-input {
  width: 120px;
  padding: 4px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 12px;
  text-align: right;
}

.manual-input:focus {
  outline: none;
  border-color: #3050c8;
}

/* xs 버튼 */
.btn-xs {
  padding: 3px 8px !important;
  font-size: 11px !important;
  border-radius: 3px;
}

/* ── 수집 실행중 / 다음 수집 배지 ── */
.badge-collecting {
  color: #e67e22;
  font-weight: 700;
  animation: blink 1s step-end infinite;
}

/* 툴바: ON 상태일 때 다음 수집 시간 (녹색) */
.badge-next-run-active {
  color: #0a8a00;
  font-size: 12px;
  font-weight: 600;
}

/* ── 스케줄 패널: 다음 수집 예정 (녹색) ── */
.schedule-next-run {
  font-size: 13px;
  color: #0a8a00;
  font-weight: 600;
  background: #f0fff0;
  padding: 3px 10px;
  border-radius: 4px;
  border: 1px solid #b2dfdb;
}

/* ── 스케줄 패널: 비활성화 상태 (회색) ── */
.schedule-deactivated {
  font-size: 13px;
  color: #999;
  font-style: italic;
}

/* ── 수집일자 경과 배지 ── */
.elapsed-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.elapsed-badge {
  font-size: 10px;
  font-weight: 600;
  padding: 1px 5px;
  border-radius: 8px;
  white-space: nowrap;
}

.elapsed-today {
  background: #e6f7e6;
  color: #0a8a00;
  border: 1px solid #b2dfb2;
}

.elapsed-1d {
  background: #fffde7;
  color: #b38600;
  border: 1px solid #ffe082;
}

.elapsed-few {
  background: #fff3e0;
  color: #d56a00;
  border: 1px solid #ffcc80;
}

.elapsed-old {
  background: #ffebee;
  color: #c62828;
  border: 1px solid #ef9a9a;
}
`, "",{"version":3,"sources":["webpack://./src/pages/status/PriceCollectPage.css"],"names":[],"mappings":"AAAA,YAAY;;AAEZ,aAAa;AACb;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,aAAa,cAAc,EAAE;AAC7B,aAAa,WAAW,EAAE;;AAE1B;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA,kBAAkB,cAAc,EAAE;AAClC,kBAAkB,cAAc,EAAE;;AAElC,gBAAgB;AAChB;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;;EAEE,eAAe;AACjB;;AAEA,eAAe,cAAc,EAAE,mBAAmB,EAAE;AACpD,kBAAkB,cAAc,EAAE,gBAAgB,EAAE;AACpD,kBAAkB,cAAc,EAAE,gBAAgB,EAAE;AACpD,YAAY,eAAe,EAAE,WAAW,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;;AAE5H,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,2BAA2B;AAC3B;EACE,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,qCAAqC;AACvC;AACA,mBAAmB,MAAM,UAAU,EAAE,EAAE;AACvC;EACE,eAAe;EACf,gBAAgB;AAClB;AACA,0BAA0B,cAAc,EAAE;AAC1C,0BAA0B,cAAc,EAAE;AAC1C;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,UAAU;AACV;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;EACE,cAAc;EACd,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA,+BAA+B;AAC/B;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B","sourcesContent":["/* 시세수집 화면 */\n\n/* ── 툴바 ── */\n.pc-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.pc-toolbar-sep {\n  width: 1px;\n  height: 20px;\n  background: #ddd;\n  margin: 0 4px;\n}\n\n.pc-check-label {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 13px;\n  color: #444;\n  cursor: pointer;\n  user-select: none;\n}\n.pc-check-label input[type=\"checkbox\"] {\n  width: 15px;\n  height: 15px;\n  cursor: pointer;\n}\n\n.pc-schedule-badge {\n  font-size: 12px;\n  color: #555;\n  margin-left: 4px;\n}\n\n.badge-on  { color: #0a8a00; }\n.badge-off { color: #999; }\n\n.btn-outline-active {\n  background: #eef0ff;\n  border-color: #4060d0;\n  color: #4060d0;\n}\n\n/* ── 바디 ── */\n.pc-body {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  gap: 12px;\n  overflow-y: auto;\n  padding: 4px 2px 12px;\n}\n\n/* ── 카드 공통 ── */\n.pc-card {\n  border: 1px solid #dde2ef;\n  border-radius: 6px;\n  background: white;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.pc-card-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  background: #f0f2f8;\n  font-size: 13px;\n  font-weight: 600;\n  color: #1a1a2e;\n  border-bottom: 1px solid #dde2ef;\n}\n\n.pc-card-body {\n  padding: 12px;\n}\n\n/* ── 스케줄 설정 카드 ── */\n.schedule-body {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.schedule-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 13px;\n}\n\n.schedule-label {\n  width: 100px;\n  color: #555;\n  flex-shrink: 0;\n}\n\n.schedule-input {\n  flex: 1;\n  max-width: 280px;\n  padding: 5px 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 13px;\n  font-family: monospace;\n}\n\n.schedule-value {\n  font-family: monospace;\n  font-size: 13px;\n  color: #333;\n  background: #f8f8f8;\n  padding: 4px 8px;\n  border-radius: 4px;\n}\n\n.schedule-hint {\n  font-size: 11px;\n  color: #888;\n  margin: 0;\n}\n\n.schedule-hint code {\n  background: #f0f0f0;\n  padding: 1px 4px;\n  border-radius: 3px;\n  font-size: 11px;\n}\n\n/* ON/OFF 토글 버튼 */\n.toggle-btn {\n  padding: 4px 16px;\n  border-radius: 12px;\n  border: none;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.toggle-on {\n  background: #0a8a00;\n  color: white;\n}\n\n.toggle-off {\n  background: #ccc;\n  color: #666;\n}\n\n.toggle-btn:disabled {\n  opacity: 0.7;\n  cursor: default;\n}\n\n/* ── 수집 결과 카드 ── */\n.result-mode {\n  font-size: 11px;\n  background: #eef0ff;\n  color: #3050c8;\n  padding: 2px 8px;\n  border-radius: 10px;\n  font-weight: 500;\n}\n\n.result-counts {\n  font-size: 12px;\n  font-weight: 400;\n  margin-left: auto;\n  color: #555;\n}\n\n.result-success { color: #0a8a00; }\n.result-fail    { color: #cc0000; }\n\n/* 시장지수 한 줄 표시 */\n.market-index-row {\n  display: flex;\n  gap: 16px;\n  padding: 8px 12px;\n  background: #fafbff;\n  border-bottom: 1px solid #eee;\n  flex-wrap: wrap;\n}\n\n.market-index-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-width: 80px;\n}\n\n.mi-label {\n  font-size: 10px;\n  color: #888;\n}\n\n.mi-value {\n  font-size: 13px;\n  font-weight: 600;\n  color: #1a1a2e;\n}\n\n/* 결과 테이블 */\n.pc-result-table-wrap {\n  max-height: 250px;\n  overflow-y: auto;\n  padding: 0 12px 10px;\n}\n\n.pc-result-table td,\n.pc-result-table th {\n  font-size: 12px;\n}\n\n.row-fail td { color: #cc0000; background: #fff5f5; }\n.status-success { color: #0a8a00; font-weight: 600; }\n.status-fail    { color: #cc0000; font-weight: 600; }\n.td-error { font-size: 11px; color: #999; max-width: 300px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n\n/* ── 최신시세 / 수동입력 테이블 ── */\n.pc-table-wrap {\n  overflow-x: auto;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.pc-price-table td,\n.pc-price-table th {\n  font-size: 12px;\n  white-space: nowrap;\n}\n\n.price-cell {\n  font-weight: 600;\n  color: #1a1a2e;\n}\n\n.col-right {\n  text-align: right !important;\n}\n\n/* ── 시장지수 과거데이터 수집 섹션 ── */\n.pc-hist-card {\n  border-left: 3px solid #4a90e2;\n}\n.pc-hist-body {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  padding: 8px 0;\n}\n.pc-hist-label {\n  font-size: 13px;\n  color: #555;\n  white-space: nowrap;\n}\n.pc-hist-date {\n  padding: 4px 8px;\n  font-size: 13px;\n  border: 1px solid #d0d7de;\n  border-radius: 4px;\n  background: #fff;\n}\n.pc-hist-progress {\n  font-size: 12px;\n  color: #4a90e2;\n  animation: blink 1s step-end infinite;\n}\n@keyframes blink { 50% { opacity: 0; } }\n.pc-hist-result {\n  font-size: 13px;\n  font-weight: 600;\n}\n.pc-hist-result.success { color: #27ae60; }\n.pc-hist-result.error   { color: #e74c3c; }\n.pc-hist-hint {\n  font-size: 11px;\n  color: #888;\n  margin: 4px 0 0;\n}\n\n/* 수동입력 필드 */\n.manual-input {\n  width: 120px;\n  padding: 4px 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 12px;\n  text-align: right;\n}\n\n.manual-input:focus {\n  outline: none;\n  border-color: #3050c8;\n}\n\n/* xs 버튼 */\n.btn-xs {\n  padding: 3px 8px !important;\n  font-size: 11px !important;\n  border-radius: 3px;\n}\n\n/* ── 수집 실행중 / 다음 수집 배지 ── */\n.badge-collecting {\n  color: #e67e22;\n  font-weight: 700;\n  animation: blink 1s step-end infinite;\n}\n\n/* 툴바: ON 상태일 때 다음 수집 시간 (녹색) */\n.badge-next-run-active {\n  color: #0a8a00;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n/* ── 스케줄 패널: 다음 수집 예정 (녹색) ── */\n.schedule-next-run {\n  font-size: 13px;\n  color: #0a8a00;\n  font-weight: 600;\n  background: #f0fff0;\n  padding: 3px 10px;\n  border-radius: 4px;\n  border: 1px solid #b2dfdb;\n}\n\n/* ── 스케줄 패널: 비활성화 상태 (회색) ── */\n.schedule-deactivated {\n  font-size: 13px;\n  color: #999;\n  font-style: italic;\n}\n\n/* ── 수집일자 경과 배지 ── */\n.elapsed-cell {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n}\n\n.elapsed-badge {\n  font-size: 10px;\n  font-weight: 600;\n  padding: 1px 5px;\n  border-radius: 8px;\n  white-space: nowrap;\n}\n\n.elapsed-today {\n  background: #e6f7e6;\n  color: #0a8a00;\n  border: 1px solid #b2dfb2;\n}\n\n.elapsed-1d {\n  background: #fffde7;\n  color: #b38600;\n  border: 1px solid #ffe082;\n}\n\n.elapsed-few {\n  background: #fff3e0;\n  color: #d56a00;\n  border: 1px solid #ffcc80;\n}\n\n.elapsed-old {\n  background: #ffebee;\n  color: #c62828;\n  border: 1px solid #ef9a9a;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
